<div class="row justify-content-center">
    <div class="col-auto">
        <img src="../../../../assets/img/Recurso 42@72x.png" alt="Silva" width="150" style="margin-bottom: 25px;">
    </div>
    <div class="col-10">
        <input type="text" [(ngModel)]="email" placeholder="Email" class="form-input">
        <input type="password" [(ngModel)]="password" placeholder="Password" class="form-input">
        <div *ngIf="errorMessage" class="form-error-msg">
            {{errorMessage}}
        </div>
        <button (click)="login()" class="form-submit-btn">INGRESAR</button>
    </div>
</div>